/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Sections4Inputs */

const en_coinvestments_lpdealoverviewcontent_sections4 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Sections4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

/**
* | output |
* | --- |
* | "Sections" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Sections4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_sections4 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Sections4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Sections4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_sections4(inputs)
});
export { coinvestments_lpdealoverviewcontent_sections4 as "coInvestments_lpDealOverviewContent_sections" }